import { call, put } from "redux-saga/effects";
import axios from "../../axiosConfig";
import { ADD_NEW_CAMPAGIN_FAILED, ADD_NEW_CAMPAGIN_SUCCESS, CJSC_EXPORT_TO_CSV_FAILED, CJSC_EXPORT_TO_CSV_SUCCESS, DELETE_CAMPAGIN_FAILED, DELETE_CAMPAGIN_SUCCESS,PAUSE_CAMPAIGN_FAILED,PAUSE_CAMPAIGN_SUCCESS,RESUME_CAMPAIGN_FAILED,RESUME_CAMPAIGN_SUCCESS, GET_ALL_CAMAGINS_FAILED, GET_ALL_CAMAGINS_SUCCESS, GET_MULITPLE_CJSCID_LIST_FAILED, GET_MULITPLE_CJSCID_LIST_SUCCESS, SORT_BY_DATE, UPDATE_CAMPAIGN_FAILED, UPDATE_CAMPAIGN_SUCCESS } from "../Actions/CampaignsActions";
import { TOAST_SHOW } from "../Actions/ToastAction";
import FileDownload from 'js-file-download';

export function* GetAllCampaignsSaga(action: any): unknown {
    let listingFilterCJSCID = action.payload.data;
    let showAll = action.payload.showAll
    try {
        const response = yield call(axios.get, listingFilterCJSCID?`getCjsc?cjscid=${listingFilterCJSCID}`:`getCjsc?showAll=${showAll}`);
        const { data, status } = response

        if (status === 200) {
            yield put({ type: GET_ALL_CAMAGINS_SUCCESS, payload: data })
            yield put({ type: SORT_BY_DATE })
        }

    } catch (error:any) {
        yield put({ type: GET_ALL_CAMAGINS_FAILED, payload: [] })
        if(error.response.status ===500){ 
          yield put({
            type: TOAST_SHOW,
            payload: { message: error.response?.data?.message ? error.response?.data?.message: "Something Went wrong please try again", severity: 'Danger', show: true },
          });
        }
    }
}

export function* addNewCampaginSaga(action: any): unknown {
  
  let {_successcallback,_activeCampaignExist,_activeCampaignSameUserId} = action.callbackFun;
 
  try {
    const response = yield call(axios.post, 'addCjsc', action.payload.data,{
      headers: { "Content-Type": "multipart/form-data" },
    });
    const { 
        //data, 
        status 
    } = response;

    if (status === 200) {
      _successcallback();
      yield put({ type: ADD_NEW_CAMPAGIN_SUCCESS, payload: true });
    }
  } catch (error:any) {
    yield put({ type: ADD_NEW_CAMPAGIN_FAILED, payload: false });
    if(error.response.data.message && error.response.data.message==='Script Name/Value Exists Already'){
      _activeCampaignExist(error.response.data.userId?"User "+error.response.data.userId:error.response.data.name?"Campaign Name "+error.response.data.name:'');
    }else if (error.response.data.message && error.response.data.message==='UserID already activated'){
      _activeCampaignSameUserId(error.response.data.dupList?error.response.data.dupList:'')
    }
    if(error.response.status ===500){ 
      yield put({
        type: TOAST_SHOW,
        payload: { message: error.response?.data?.message ? error.response?.data?.message: "Something Went wrong please try again", severity: 'Danger', show: true },
      });
    }
  }
}

export function* deleteCampaginSaga(action: any): unknown {
  try {
    const response = yield call(axios.post, `delCjsc`, action.payload);
    const {
      //data,
      status,
    } = response;

    if (status === 200) {
      yield put({ type: DELETE_CAMPAGIN_SUCCESS, payload: true });
    }
  } catch (error) {
    yield put({ type: DELETE_CAMPAGIN_FAILED, payload: false });
  }
}

export function* pauseCampaignSaga(action: any): unknown {
  try {
    const response = yield call(axios.post, `pauseCjsc`, action.payload);
    const {
      //data,
      status,
    } = response;

    if (status === 200) {
      yield put({ type: PAUSE_CAMPAIGN_SUCCESS, payload: true });
    }
  } catch (error) {
    yield put({ type: PAUSE_CAMPAIGN_FAILED, payload: false });
  }
}

export function* resumeCampaignSaga(action: any): unknown {
  try {
    const response = yield call(axios.post, `resumeCjsc`, action.payload);
    const {
      //data,
      status,
    } = response;

    if (status === 200) {
      yield put({ type: RESUME_CAMPAIGN_SUCCESS, payload: true });
    }
  } catch (error) {
    yield put({ type: RESUME_CAMPAIGN_FAILED, payload: false });
  }
}

export function* getCJSCIdDropdownListSaga(action: any): unknown {
  try {
    const response = yield call(axios.get, 'getCjscUsers');
    const { data, status } = response 

    if (status === 200) {
      yield put({ type: GET_MULITPLE_CJSCID_LIST_SUCCESS, payload: data });
    }
  } catch (error) {
    yield put({ type: GET_MULITPLE_CJSCID_LIST_FAILED, payload: false });
  } 
}

export function* cjscListExportToCsvSaga(action: any): unknown {
  let listingFilterCJSCID = action.payload.data;
  let showAll = action.payload.showAll
  // console.log(showAll);
  try {
      const response = yield call(axios.get, listingFilterCJSCID?`getCjscDataCSV?cjscid=${listingFilterCJSCID.value}&showAll=${showAll}`:`getCjscDataCSV?showAll=${showAll}`); 

      const { data, status } = response

      if (status === 200) {
          yield put({ type: CJSC_EXPORT_TO_CSV_SUCCESS });
          FileDownload(data, `cjsc_list.csv`);
      }

  } catch (e: any) {
      yield put({ type: CJSC_EXPORT_TO_CSV_FAILED });
      yield put({
          type: TOAST_SHOW,
          payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
      });
  }
}

export function* updateCampaignSaga(action: any): unknown {
  try {
    const response = yield call(axios.post, `updateCjsc`, action.payload.data);
    const { status } = response;

    if (status === 200) {
      yield put({ type: UPDATE_CAMPAIGN_SUCCESS, payload: true });
      action.callbackFun();
    }
  } catch (error:any) {
    yield put({ type: UPDATE_CAMPAIGN_FAILED, payload: false });
    if(error.response.status ===500){ 
      yield put({
        type: TOAST_SHOW,
        payload: { message: error.response?.data?.message ? error.response?.data?.message: "Something Went wrong please try again", severity: 'Danger', show: true },
      });
    }
  }
}